import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePCrmInvoiceType, PCrmInvoiceType } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<PCrmInvoiceType>
      useData={usePCrmInvoiceType}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
